import React from "react"

import {Title} from "./styles"

export function LitTitle({children, ...rest}){
  return (
    <Title {...rest}>{children}</Title>
  )
}
